import { configFields, credentialFields } from './fieldTemplates';

/*
 * Get Formatic form field definition for auth.
 */
export const getAuthFieldsForAuthType = (authType: string) => {
  const authConfigFields = configFields[authType] || [];
  const authCredentialFields = credentialFields[authType] || [];
  return [...authConfigFields, ...authCredentialFields];
};
